import * as React from "react";
import { connect } from "react-redux";
import { isRequestActive } from "redux-request-loading";

import { Modal, Button } from "semantic-ui-react";

import { Appointment } from "@teamprevent/common/calendar";

import { ApplicationState, BookAppointmentTaskListModel, BookAppointmentErrors } from "../models";
import { basePathSelector } from "../selectors";
import { BOOK_INTO_CLINIC } from "../actionTypes";
import { loadClinic } from "../../calendar/clinics/actions";

import { BookClinicAppointmentForm } from "./BookClinicAppointmentForm";

import { push } from "redux-little-router";

interface StateProps {
    clinic: Appointment;
    basePath: string;
    clinicId: string;
    bookingAppointment: boolean;
    bookTask: BookAppointmentTaskListModel;
    bookAppointmentErrors: BookAppointmentErrors;
}

interface DispatchProps {
    dispatchPush: (path: string) => void;
    dispatchLoadClinic: (clinicId: string) => void;
}

interface MergedProps {
    clinic: Appointment;
    bookingAppointment: boolean;
    bookTask: BookAppointmentTaskListModel;
    bookAppointmentErrors: BookAppointmentErrors;
    close: () => void;
    loadClinic: () => void;
}

export class BookClinicAppointmentUnconnected extends React.Component<MergedProps> {
    private bookForm: any;

    public componentDidMount() {
        if (!this.props.clinic) {
            this.props.loadClinic();
        }
    }

    public render() {
        return (
            <Modal open closeOnDimmerClick={false}>
                <Modal.Content>
                    <BookClinicAppointmentForm
                        bookTask={this.props.bookTask}
                        ref={instance => this.bookForm = instance}
                        clinic={this.props.clinic}
                        bookAppointmentErrors={this.props.bookAppointmentErrors}
                    />
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.props.close} content="Cancel" />
                    <Button
                        loading={this.props.bookingAppointment}
                        disabled={this.props.bookingAppointment}
                        onClick={() => this.bookForm.submit()}
                        content="Save"
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    basePath: basePathSelector(state),
    bookingAppointment: isRequestActive(state, BOOK_INTO_CLINIC),
    bookTask: state.bookAppointments.bookAppointmentTasks.find(t => t.id === state.router.params.bookTaskId),
    clinicId: state.router.params.clinicId,
    clinic: state.clinic.clinics.find(clinic => clinic.id === state.router.params.clinicId),
    bookAppointmentErrors: state.bookAppointments.bookAppointmentErrors
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
    dispatchPush: (path: string) => dispatch(push(path)),
    dispatchLoadClinic: (clinicId: string) => dispatch(loadClinic({ clinicId }))
});

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps): MergedProps => {
    const { basePath, clinicId, ...propsFromState } = stateProps;
    return {
        ...propsFromState,
        close: () => dispatchProps.dispatchPush(basePath),
        loadClinic: () => dispatchProps.dispatchLoadClinic(clinicId)
    };
};

export const BookClinicAppointment = connect(mapStateToProps, mapDispatchToProps, mergeProps)(BookClinicAppointmentUnconnected);
